// A service for managing GUIDs in IndexedDB
const BrowserIDService = (() => {
    // Open or create an IndexedDB database
    function openDatabase() {
      return new Promise((resolve, reject) => {
        const request = indexedDB.open('GUIDDatabase', 1);
  
        request.onupgradeneeded = (event) => {
          const db = event.target.result;
          if (!db.objectStoreNames.contains('GUIDStore')) {
            db.createObjectStore('GUIDStore', { keyPath: 'id' });
          }
        };
  
        request.onsuccess = (event) => {
          resolve(event.target.result);
        };
  
        request.onerror = (event) => {
          reject(event.target.error);
        };
      });
    }
  
    // Store a GUID in IndexedDB
    async function storeGUID(guid) {
      const db = await openDatabase();
      return new Promise((resolve, reject) => {
        const transaction = db.transaction('GUIDStore', 'readwrite');
        const store = transaction.objectStore('GUIDStore');
        const request = store.put({ id: 'guid', value: guid });
  
        request.onsuccess = () => {
          resolve();
        };
  
        request.onerror = (event) => {
          reject(event.target.error);
        };
      });
    }
  
    // Retrieve the GUID from IndexedDB
    async function getGUID() {
      const db = await openDatabase();
      return new Promise((resolve, reject) => {
        const transaction = db.transaction('GUIDStore', 'readonly');
        const store = transaction.objectStore('GUIDStore');
        const request = store.get('guid');
  
        request.onsuccess = (event) => {
          resolve(event.target.result?.value || null);
        };
  
        request.onerror = (event) => {
          reject(event.target.error);
        };
      });
    }
  
    // Generate a new GUID
    function generateGUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
        const random = (Math.random() * 16) | 0;
        const value = char === 'x' ? random : (random & 0x3) | 0x8;
        return value.toString(16);
      });
    }

    async function getBrowserId(){
      const guid = await getGUID();
      if(guid == null){
        const newGuid = generateGUID();
        await storeGUID(newGuid);
        return newGuid;
      }
      return guid;
    }
  
    // Public API
    return {
      getBrowserId,
      // getGUID,
      // generateGUID,
    };
  })();

  export default BrowserIDService;
  
  // // Example usage
  // (async () => {
  //   const newGUID = GUIDService.generateGUID();
  //   console.log('Generated GUID:', newGUID);
  
  //   // Store the GUID
  //   await GUIDService.storeGUID(newGUID);
  //   console.log('GUID stored successfully.');
  
  //   // Retrieve the GUID
  //   const retrievedGUID = await GUIDService.getGUID();
  //   console.log('Retrieved GUID:', retrievedGUID);
  // })();
  